import { defineStore } from 'pinia';
export var useAuthorizationStore = defineStore('authorization', {
    state: function () { return ({
        token: null,
        isAuthorize: false,
    }); },
    getters: {
        authToken: function (state) {
            return state.token;
        },
    },
    actions: {
        setAuthorize: function (token) {
            this.token = token;
            this.isAuthorize = !!token;
        },
        resetAuthorize: function () {
            this.token = null;
            this.isAuthorize = false;
        },
    },
    persist: true,
});
